module.exports = __webpack_public_path__ + "static/media/professional-development.9f3ba646.svg";